var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchSubmitArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 16,
    viewBox: "0 0 23 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.9954 7.56041C22.9954 7.78751 22.9092 8.0146 22.7367 8.18708L16.0561 14.8677C15.7111 15.2127 15.1506 15.2127 14.8056 14.8677C14.4606 14.5228 14.4606 13.9622 14.8056 13.6173L20.8596 7.56329L14.8056 1.50929C14.4606 1.16434 14.4606 0.603782 14.8056 0.258825C15.1505 -0.0861321 15.7111 -0.0861321 16.0561 0.258825L22.7367 6.93949C22.9092 7.11197 22.9954 7.33906 22.9954 7.56616L22.9954 7.56041Z",
    fill: "#616063"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9971 7.56041C22.9971 8.0491 22.6004 8.4458 22.1117 8.4458L0.88539 8.4458C0.396701 8.4458 6.43855e-07 8.0491 6.22494e-07 7.56041C6.01133e-07 7.07172 0.396701 6.67502 0.88539 6.67502L22.1146 6.67502C22.6033 6.67502 23 7.07172 23 7.56041L22.9971 7.56041Z",
    fill: "#616063"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchSubmitArrow);
export default __webpack_public_path__ + "static/media/SearchSubmitArrow.7ef06e56a814a644ee22657c45add961.svg";
export { ForwardRef as ReactComponent };